export default __webpack_public_path__ + "static/media/icon_black_lives_matter.fc0c895b.svg";